import { useConfig } from 'Components/ConfigProvider';
import themes from 'themes';
import Config from 'config';

const getTheme = () => {
  return themes[Config.PACKAGE_SUFFIX];
};

export const useTheme = () => {
  const config = useConfig();
  return themes[config.PACKAGE_SUFFIX];
};

export default getTheme;
